export function getMeetingGridOptions(statusType) {
  return {
    suppressScrollOnNewData: true,
    suppressMultiSort: true,
    getRowId: (params) => String(params.data?.["Meeting Id"] ?? ""),
    isRowSelectable: (node) => {
      if (!node?.data) return false;
      return node.data.currentStatus === statusType || !node.data.currentStatus;
    },
  };
}

/** Rows are filtered on the server; keep filter UI but do not re-filter loaded rows (avoids empty/partial pages). */
const serverOnlyTextMatcher = () => true;

export function createDefaultColDef() {
  return {
    sortable: false,
    filter: true,
    filterParams: {
      textMatcher: serverOnlyTextMatcher,
    },
    editable: true,
    resizable: true,
    floatingFilter: true,
    flex: window.innerWidth < 991 ? 0 : 1,
    minWidth: 110,
  };
}
